import { render, staticRenderFns } from "./smsbutton.vue?vue&type=template&id=0f24d480&scoped=true&"
import script from "./smsbutton.vue?vue&type=script&lang=js&"
export * from "./smsbutton.vue?vue&type=script&lang=js&"
import style0 from "./smsbutton.vue?vue&type=style&index=0&id=0f24d480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f24d480",
  null
  
)

export default component.exports